'use strict';

(function () {
	angular.module('natiwi.core.cdn', []).config(['$sceDelegateProvider', function ($sceDelegateProvider) {
		// Добавить CDN в белый список для кросс-доменных запросов.
		$sceDelegateProvider.resourceUrlWhitelist(['self', // Разрешить загрузки с текущего домена.
		'http://cdn.natiwi.com/**', 'https://cdn.natiwi.com/**']);
	}]);
})();